import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import About from './pages/About'
import Contact from './pages/Contact'
import Industories from './pages/Industories'
import News from './pages/News'
import Products from './pages/Products'
import Home from './pages/Home'
import Career from './pages/Career'
import ApplicationForm from './pages/ApplicationForm'
import Sustainability from './pages/about/Sustainability'
import Quality from './pages/about/Quality'
import Innovation from './pages/about/Innovation'
import CustomerCenter from './pages/about/CustomerCenter'
import OilGas from './pages/solutions/OilGas';
import WaterWell from './pages/solutions/WaterWell';
import Automotive from './pages/solutions/Automotive';
import CivilSector from './pages/solutions/CivilSector';
import SteelIndustry from './pages/solutions/SteelIndustry';
import InvestorDashboard from './pages/investor_financial_dashboard';
import Faq from './pages/Faq';

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route element = {<Layout />}>
            {/* <Route path="/" element={ <Home/>} /> */}
            <Route index element={<Home />} />
            <Route path="/about" element={ <About/>} />
            <Route path="/about/quality" element={ <Quality/>} />
            <Route path="/about/innovation" element={ <Innovation/>} />
            <Route path="/about/customer-center" element={ <CustomerCenter/>} />
            <Route path="/about/sustainability" element={ <Sustainability/>} />
            <Route path="/contactUs" element={ <Contact/>} />
            <Route path="/solutions" element={ <Industories/>} />
            <Route path="/solutions/oil-gas" element={ <OilGas/>} />
            <Route path="/solutions/water-well" element={ <WaterWell/>} />
            <Route path="/solutions/automotive" element={ <Automotive/>} />
            <Route path="/solutions/civil-sector" element={ <CivilSector/>} />
            <Route path="/solutions/steel-industry" element={ <SteelIndustry/>} />
            <Route path="/news" element={ <News/>} />
            <Route path="/dashboard" element={ <InvestorDashboard />} />
            <Route path="/products" element={ <Products/>} />
            <Route path="/career" element={ <Career />} />
            <Route path="/career/application-form" element={ <ApplicationForm />} />
            <Route path="/faq" element={ <Faq />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App